import { useRef } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';

import { StyledLabel, StyledInput } from './styles';

const Input = ({
  label,
  displayLabel = 'hide',
  arialabel = '',
  state,
  stateKey,
  onChange,
  min = 0,
  dataInputName = '',
}) => {
  const intl = useIntl();
  const ref = useRef(null);

  const onClick = () => {
    ref.current.select();
  };

  return (
    <>
      <StyledLabel
        className={displayLabel}
        htmlFor={`${label.toLowerCase().split(' ').join('-')}-label`}
        aria-label={arialabel}
      >
        {label}
      </StyledLabel>
      <StyledInput
        locale={intl.locale}
        data-input-name={dataInputName}
        id={`${label.toLowerCase().split(' ').join('-')}-label`}
        type="number"
        value={state}
        min={min}
        ref={ref}
        onChange={e => onChange(stateKey, parseInt(e.target.value, 10))}
        onClick={onClick}
        aria-label={arialabel}
      />
    </>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
  displayLabel: PropTypes.string,
  arialabel: PropTypes.string,
  state: PropTypes.number.isRequired,
  stateKey: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  dataInputName: PropTypes.string,
};

export default Input;
